/*
 * Copyright 2017-2020 Narbase technologies and contributors. Use of this source code is governed by the MIT License.
 */

package com.narbase.letsgo.router

abstract class CrudEndPoint<DtoType : Any, ListRequestDtoType : Any> {

    val addEndpoint = AddEndpoint<DtoType>()
    val updateEndpoint = UpdateEndpoint<DtoType>()
    val deleteEndpoint = DeleteEndpoint()
    val listEndpoint = ListEndpoint<DtoType, ListRequestDtoType>()

    class AddEndpoint<DtoType : Any> : EndPoint<DtoType, DtoType>()

    class UpdateEndpoint<DtoType : Any> : EndPoint<DtoType, DtoType>()
    class DeleteEndpoint : EndPoint<DeleteEndpoint.RequestDto, Unit>() {
        class RequestDto(
                val id: String?
        )

    }

    class ListEndpoint<DtoType : Any, ListRequestDtoType>
        : EndPoint<ListEndpoint.RequestDto, ListEndpoint.ResponseDto<DtoType>>() {
        class RequestDto(
                val pageNo: Int = 0,
                val pageSize: Int? = null,
                val searchTerm: String? = "",
                val filters: Map<String, String>?,
                val data: String? = null
        )

        class ResponseDto<DtoType>(
                val list: Array<DtoType>,
                val total: Int
        )


    }


}